<template>
    <div id="product-details">
        <div class="mt-4"></div>
        <section id="product-details-section" class="">
            <div class="product-details-container">
                <div class="row">
                    <template v-if="$page.props.notices.length > 0 && $page.props.notices_show">
                        <Notice :notice="notice" :key="notice.name" v-for="notice in $page.props.notices"></Notice>
                    </template>
                    <div class="col-lg-5 product-lg-image border">
                        <DetailGallery :title="product.title" :images="product.gallery" :default-src="product.featured_image" />
                    </div>
                    <div class="col-lg-7 product-all-description">
                        <div class="title-date-catagory">
                            <h3 class="pd-title mt-2 text-capitalize">{{ product.title }}</h3>
                            <h3 style="font-size: 1rem !important;" class="pd-title mt-2 text-capitalize" v-if="product.title_en && (product.title != product.title_en)">Translation: {{ product.title_en }}</h3>
                            <h6 class="text-secondary mt-2">
                                <em>{{ product.added_date }}</em>
                                <Bookmark type="detail" :is-winning="product.is_winning" :id="product.id" :is-bookmark="product.bookmarked" :key="product.id+product.bookmarked" />
                                <span class="cursor-pointer"  @click="showEmbed({keyword: product.title, 'country': product.country.code.toUpperCase()})">
                                    <span class="iconify text-danger ms-2" data-height="40px" data-icon="fluent:data-trending-16-filled" data-inline="false"></span>
                                </span>
                            </h6>
                            <h6><em>{{ product.country_title }}</em></h6>
                            <h4 class="mt-2 buttons">
                                <button class="btn btn-sm btn-orange" v-for="category in product.product_categories">{{ category.title }}</button>
                            </h4>
                            <p v-if="product.bookmark" class="mt-2 alert alert-secondary p-2"><strong>Notes:</strong> {{ product.bookmark.notes }}</p>
                        </div>

                        <div class="row analytics-profit-cost mt-2" v-if="product.graph.has_graph">
                            <div class="col-md-12 analytics p-2">
                                <div class="wrapper">
                                    <h5>Trend Graph from Google Trends</h5>
                                    <h6 class="alert-dark p-2 text-left">
                                        <span class="fw-bold">Trend Captured On:</span> <span class="text-capitalize">{{ product.graph.updated_on }}</span> <br>
                                        <span class="fw-bold small">Note: </span> <span class="small">Trend Graph varies every hour, so it might change when you search again on Google Trends</span>
                                    </h6>
                                    <div class="p-3">
                                       <div class="row">
                                           <div class="col-md-12 text-center">
                                               <h4>Search Trend over Time</h4>
                                               <p>{{ product.graph.time_range }}</p>
                                           </div>
                                           <div class="col-md-12 mt-2">
                                                <VueApexCharts type="line" :series="product.graph.data" :options="product.graph.options" />
                                           </div>
                                       </div>
                                    </div>
                                </div>
                            </div>
                            <hr style="height: 3px" class="my-3" />
                        </div>
                        <div class="row analytics-profit-cost mt-2" v-else>
                            <div class="col-md-12 analytics p-2">
                                <div class="wrapper">
                                    <h5>Trend Graph from Google Trends</h5>
                                    <h6 class="alert-dark p-2 text-left">
                                        <span class="fw-bold small">Note: </span> <span class="small">Trend Graph varies every hour, so it might change when you search again on Google Trends</span>
                                    </h6>
                                    <div class="p-3">
                                        <div class="row">
                                            <div class="col-md-12 mt-2">
                                                <GoogleTrend id="d_google_trend" :keyword="product.title" :geo="product.country_code" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr style="height: 3px" class="my-3" />
                        </div>




                        <div class="row analytics-profit-cost mt-4">
                            <div class="col-md-6 analytics p-2">
                                <div class="wrapper">
                                    <h5>Analytics</h5>
                                    <h6 class="alert-dark p-2 text-center"><span class="fw-bold">Keyword:</span> <span class="text-capitalize">{{ product.title }}</span></h6>
                                    <div class="trends-sound">
                                        <div class="box">
                                            <h1>{{ product.cpc || 'N/A' }}</h1>
                                            <h5>CPC</h5>
                                        </div>
                                        <div class="box">
                                            <h1>{{ product.competition || 'N/A' }}</h1>
                                            <h5>Competition</h5>
                                        </div>
                                        <div class="box">
                                            <h1>{{ product.volume || 'N/A' }}</h1>
                                            <h5>Volume</h5>
                                        </div>

                                        <template v-if="product.is_winning == 1">
                                            <div class="box">
                                                <h1 :class="'alert-'+(product.rating_weekly_icon == 'up' ? 'success' : 'danger')">
                                                    <template v-if="! ratingWeekly">
                                                        <span
                                                            data-height="14px" class="iconify mb-1 mx-1"
                                                            data-icon="bi:info-circle" data-inline="false"
                                                            role="button" tabindex="0"
                                                            data-bs-toggle="popover" data-bs-trigger="focus"
                                                            data-bs-content="Trend Percentage is Calculated after 7 days of addition"
                                                        ></span>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="product.trend_updating">
                                                            Updating
                                                        </template>
                                                        <template v-else>
                                                            <span :class="'iconify text-'+(product.rating_weekly_icon == 'up' ? 'success' : 'danger')"
                                                                  :data-icon="'ph:trend-'+product.rating_weekly_icon+'-bold'" data-inline="false">
                                                        </span>{{ ratingWeekly }}
                                                        </template>
                                                    </template>
                                                </h1>
                                                <h5 style="font-size: 12px;">{{ product.trend_updating_title }} </h5>
                                            </div>
<!--                                            <div class="box">
                                                <h1 :class="'alert-'+(product.rating_monthly_icon == 'up' ? 'success' : 'danger')">
                                                    <span v-if="product.rating_monthly"
                                                          :class="'iconify text-'+(product.rating_monthly_icon == 'up' ? 'success' : 'danger')"
                                                          :data-icon="'ph:trend-'+product.rating_monthly_icon+'-bold'" data-inline="false">
                                                    </span>
                                                    <template v-if="! ratingMonthly">N/A</template>
                                                    <template v-else>{{ ratingMonthly }}</template>
                                                </h1>
                                                <h5>Monthly Trend</h5>
                                            </div>-->
                                        </template>
                                        <template v-else>
                                            <div class="box">
                                                <h1 class="alert-success"><span class="iconify text-success" data-icon="ph:trend-up-bold" data-inline="false"></span>{{ product.rating }}</h1>
                                                <h5>Trend</h5>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6  analytics profit-cost p-2" v-if="product.product_cost">
                                <div class="wrapper">
                                    <h5>Your Profit Cost</h5>
                                    <div class="trends-sound">
                                        <div class="box">
                                            <h1>{{ product.selling_price }}</h1>
                                            <h5>Selling Price</h5>
                                        </div>
                                        <div class="box">
                                            <h1 class="text-danger fw-bold">{{ product.product_cost }}</h1>
                                            <h5>Product Cost</h5>
                                        </div>
                                        <div class="box">
                                            <h1 class="text-success fw-bold">{{ product.product_profit }}</h1>
                                            <h5>Profit Margin</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr style="height: 3px" class="my-3" />
                        </div>

                        <!-- description part here -->
                        <DetailDescription :start="product.description_start" :end="product.description_end" v-if="product.description" />

                        <!-- source and review section -->
                        <div class="source-and-review p-0" v-if="product.sources.length">
                            <div class="row">
                                <div class="col-md-6 p-3" v-for="source in product.sources">
                                    <div class="wrapper">
                                        <h6>Source: <span>{{ source.title }}</span></h6>
                                        <h6>Price: <span>{{ source.price }}</span></h6>
                                        <h6>Reviews: <span>{{ source.reviews }}</span></h6>
                                        <h6 v-if="source.order">Orders: <span>{{ source.order }}</span></h6>
                                        <h6>
                                            Rating:
                                            <span v-if="source.rating" :title="source.rating" data-bs-toggle="tooltip">
                                                <span v-if="source.rating > 0" class="iconify text-warning" :data-icon="source.rating <= 0.7 ? 'bi:star-half' : 'bi:star-fill'" data-inline="false"></span>
                                                <span v-if="source.rating > 1" class="iconify text-warning" :data-icon="source.rating <= 1.7 ? 'bi:star-half' : 'bi:star-fill'" data-inline="false"></span>
                                                <span v-if="source.rating > 2" class="iconify text-warning" :data-icon="source.rating <= 2.7 ? 'bi:star-half' : 'bi:star-fill'" data-inline="false"></span>
                                                <span v-if="source.rating > 3" class="iconify text-warning" :data-icon="source.rating <= 3.7 ? 'bi:star-half' : 'bi:star-fill'" data-inline="false"></span>
                                                <span v-if="source.rating > 4" class="iconify text-warning" :data-icon="source.rating <= 4.7 ? 'bi:star-half' : 'bi:star-fill'" data-inline="false"></span>
                                            </span>
                                            <span v-else>N/A</span>
                                        </h6>
                                        <a :href="source.link" v-if="source.link" class="btn btn-sm theme-btn py-2 mt-3 btn-orange" target="_blank">Visit Link</a>
                                    </div>
                                </div>

                            </div>
                            <hr style="height: 3px" class="my-3" />
                        </div>

                        <!-- links part -->
                        <div class="links-part" v-if="product.links.length > 0">
                            <div class="wrapper">
                                <h5 class="mb-3"><span class="iconify" data-icon="heroicons-solid:link" data-inline="false"></span> <span>Links</span></h5>
                                <ul class="list-unstyled ps-4">
                                    <li v-for="link in product.links" >
                                        <a v-if="link.src.length > 0" target="_blank" :href="link.src">{{link.title }}</a>
                                    </li>
                                </ul>
                            </div>
                            <hr style="height: 3px" class="my-3" />
                        </div>

                        <!-- Facebook ads part -->
                        <div class="facebook-ads" v-if="product.fb_ads_images.length > 0">
                            <h5 class="mb-2">Facebook Ads</h5>
                            <div class="row row-cols-3 g-3" id="light-box-area">
                                <div
                                    v-for="(src, index) in product.fb_ads_images"
                                    :key="index"
                                    @click="() => showFbAdsImg(index)">
                                    <img :src="src.src" class="img-fluid light-box-img" :alt="src.title" />
                                </div>
                            </div>
                            <hr style="height: 3px" class="my-3" />
                        </div>
                        <vue-easy-lightbox
                            v-if="product.fb_ads_images.length > 0"
                            moveDisabled
                            scrollDisabled
                            escDisabled
                            :visible="fbAdsImgVisible"
                            :imgs="product.fb_ads_images"
                            :index="fbAdsImgIndex"
                            @hide="hideFbAdsImg">
                        </vue-easy-lightbox>
                        <!-- targeting part -->
                        <div class="targeting-part" v-if="product.target_country">
                            <h5 class="mb-2">Targeting</h5>
                            <div class="targetng-wrapper">
                                <div class="box">
                                    <h1>{{ product.target_country }}</h1>
                                    <h6>Country</h6>
                                </div>
                                <div class="box">
                                    <h1>{{ product.target_audience }}</h1>
                                    <h6>Audience Size</h6>
                                </div>
                                <div class="box">
                                    <h1>{{ product.target_age }}</h1>
                                    <h6>Age Range</h6>
                                </div>
                                <div class="box">
                                    <h1 class="text-capitalize">{{ product.target_gender }}</h1>
                                    <h6>Gender</h6>
                                </div>
                            </div>
                            <hr style="height: 3px" class="my-3" />
                        </div>

                        <div class="custom-alert-box" v-if="product.target_interest.length > 0">
                            <div class="ms-4">
                                <h4 class="dim-text mb-2">Interest</h4>
                                <div class="col-md-12">
                                    <table class="table table-sm">
                                        <tbody>
                                            <tr v-for="interest in product.target_interest">
                                                <td class="text-left text-dark">{{ interest }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- embed modal -->
            <div class="modal" tabindex="-1" :id="embed.modalId">
                <div class="modal-dialog modal-dialog-centered modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title text-capitalize">{{ embed.keyword  }}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="embed.keyword=''"></button>
                        </div>
                        <div class="modal-body p-0 m-0">
                            <GoogleTrend :id="embed.id" :keyword="embed.keyword" :geo="embed.country" />
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn s-sm btn-secondary btn-orange" data-bs-dismiss="modal" @click="embed.keyword=''">Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- embed end modal -->
        </section>
    </div>
</template>

<script>



import RecordNotFound from "@s/Components/RecordNotFound";
import Bookmark from "../components/Bookmark";
import VueEasyLightbox from 'vue-easy-lightbox'
import DetailGallery from "./Gallery";
import DetailDescription from "./Description";
import GoogleTrend from "@u/Pages/Product/components/GoogleTrend";
import Notice from "../components/Notice";
import VueApexCharts from "vue3-apexcharts";

export default {
    name: 'DetailPage',
    components: {
        GoogleTrend,
        DetailDescription,
        DetailGallery,
        Bookmark,
        RecordNotFound,
        Notice,
        VueEasyLightbox,
        VueApexCharts,
    },
    props: ["product", "data", "pageTitle"],
    data() {
        return {
            fbAdsImgVisible: false,
            fbAdsImgIndex: 0,
            defaultSliderImage: this.product.featured_image,
            embed: {
                modalId: 'detail-st-modal',
                id: 'detail-st',
                keyword: '',
                country: 'US',
                counter: 0,
            },
        }
    },
    computed:{
        ratingWeekly() {
            return this.product.rating_weekly;
        },
        ratingMonthly() {
            return this.product.rating_monthly;
        }
    },
    mounted() {
        try {
            const swiper = new Swiper(".mySwiper", {
                slidesPerView: 4,
                spaceBetween: 20,
            });
        } catch (err) {}

        [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
            .map((ttel) => new bootstrap.Tooltip(ttel));

        setTimeout(() => {
            [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
                .map((ptel) => new bootstrap.Popover(ptel));
        }, 300)

    },
    created(){
        document.title = this.pageTitle;
    },
    methods: {
        submit() {
            this.loading = true;
            var that = this;
            let queryString = Object.keys(this.f).map(function (key) {
                if (that.f[key] == null) {
                    that.f[key] = '';
                }
                return key + '=' + that.f[key]
            }).join('&');
            this.$inertia.replace(__st.currentRoute + "?" + queryString)
        },

        showFbAdsImg(index) {
            this.fbAdsImgIndex = index
            this.fbAdsImgVisible = true
        },

        hideFbAdsImg() {
            this.fbAdsImgVisible = false
        },

        showEmbed(params) {
            this.embed.keyword = params.keyword;
            this.embed.country = params.country;
            const myModal = new bootstrap.Modal(document.getElementById(this.embed.modalId))
            myModal.show();
        },
    }
}
</script>
<style>
[v-cloak] { display:none; }
</style>
